module.exports = __webpack_public_path__ + "assets/tongzhifabu.5b32158c.svg";